import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

function Footer({ setContactActive }) {
  const contactHandler = useCallback((e) => {
    const button = e.target.closest('button');

    setContactActive({
      formType: button.dataset.source || button.innerText,
      title: button.innerText,
    });
  }, []);

  return (
    <footer className="bg-lightblue footerComp">
      <div className="container">
        <div className="flex-row">
          <div className="col col-3">
            <img
              src="/img/algobulls-logo.svg"
              alt="algobulls"
              className="footer-logo"
            />
            <div className="footer-social">
              <div className="links">
                <a
                  href="https://algobulls.com/help"
                  target="_blank"
                  rel="noopener noreferrer">
                  <img src="/img/help.svg" alt="help" />
                </a>
                <a
                  href="https://algobulls.com/blog"
                  target="_blank"
                  rel="noopener noreferrer">
                  <img src="/img/iconBlog.svg" alt="blog" />
                </a>
                <a
                  href="https://www.youtube.com/c/AlgoBulls"
                  target="_blank"
                  rel="noopener noreferrer">
                  <img src="/img/youtube.svg" alt="youtube" />
                </a>{' '}
                <a
                  href="https://github.com/algobulls"
                  target="_blank"
                  rel="noopener noreferrer">
                  <img src="/img/github.svg" alt="github" />
                </a>
              </div>
              <div className="links">
                <a
                  href="https://in.linkedin.com/company/algobulls"
                  target="_blank"
                  rel="noopener noreferrer">
                  <img src="/img/linkedin.svg" alt="linkedin" />
                </a>
                <a
                  href="https://www.facebook.com/algobullsalgotrading/"
                  target="_blank"
                  rel="noopener noreferrer">
                  <img src="/img/facebook.svg" alt="facebook" />
                </a>
                <a
                  href="https://twitter.com/AlgoBulls"
                  target="_blank"
                  rel="noopener noreferrer">
                  <img src="/img/twitter.svg" alt="twitter" />
                </a>
                <a
                  href="https://instagram.com/algobulls?igshid=YmMyMTA2M2Y="
                  target="_blank"
                  rel="noopener noreferrer">
                  <img src="/img/instagram.svg" alt="instagram" />
                </a>
              </div>
            </div>
          </div>
          <div className="col col-5">
            {!process.env.GATSBY_AI && (
              <div className="footer-links-block">
                <div className="links-single">
                  <h3>Explore</h3>
                  <Link to="/phoenix-copilot">
                    Phoenix &quot;AI&quot; Copilot
                  </Link>
                  <Link to="/phoenix">Phoenix</Link>
                  <Link to="/odyssey">Odyssey</Link>
                  <Link to="/enterprise">Enterprise</Link>
                  <Link to="/pricing">Pricing</Link>
                  <a
                    href="https://algobulls.com/help/article/faqs"
                    target="_blank"
                    rel="noopener noreferrer">
                    FAQ
                  </a>
                </div>

                <div className="links-single">
                  <h3>Contact</h3>
                  {[
                    {
                      text: 'Apply As Strategist',
                      id: 0,
                      formType: 'applyAsStrategist',
                    },
                    {
                      text: 'Apply As Broker',
                      id: 1,
                      formType: 'applyAsBroker',
                    },
                    {
                      text: 'Apply As Partner',
                      id: 2,
                      formType: 'applyAsPartner',
                    },
                  ].map(({ id, text, formType }) => (
                    <button
                      key={id}
                      type="button"
                      className="button-unstyled"
                      data-source={formType}
                      onClick={contactHandler}>
                      {text}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="col col-4 footer-container">
            {!process.env.GATSBY_AI && (
              <div className="footer-phone">
                <svg width="20" height="14" viewBox="0 0 20 14" fill="none">
                  <path
                    d="M19.5167 12.9165C19.1211 13.3915 18.5349 13.6662 17.9167 13.6665H2.0834C1.46519 13.6662 0.879023 13.3915 0.483398 12.9165L8.12506 6.5498L8.91674 7.09148C9.56889 7.54148 10.4313 7.54148 11.0834 7.09148L11.8751 6.5498L19.5167 12.9165Z"
                    fill="#1E88E5"
                  />
                  <path
                    d="M19.6333 1.24139L11.875 6.5497L11.0833 7.09138C10.4312 7.54138 9.56879 7.54138 8.91665 7.09138L8.12497 6.5497L0.366699 1.23303C0.757089 0.670106 1.3983 0.333935 2.08338 0.333037H17.9167C18.6048 0.329404 19.2492 0.670341 19.6333 1.24139Z"
                    fill="#64B5F6"
                  />
                  <path
                    d="M8.12502 6.55003L0.483356 12.9167C0.170584 12.5429 -0.000548905 12.0708 3.70314e-05 11.5834V2.41672C-0.00250203 1.99394 0.125584 1.58066 0.366716 1.2334L8.12502 6.55003Z"
                    fill="#2196F3"
                  />
                  <path
                    d="M20 2.4167V11.5834C20.0005 12.0708 19.8294 12.5428 19.5167 12.9167L11.875 6.55001L19.6333 1.2417C19.8732 1.58646 20.0012 1.99666 20 2.4167Z"
                    fill="#2196F3"
                  />
                </svg>

                <p>
                  <a
                    href="mailto:support@algobulls.com"
                    style={{ fontWeight: '400' }}>
                    support@algobulls.com
                  </a>
                </p>
              </div>
            )}
            <div className="footer-phone" style={{ alignItems: 'flex-start' }}>
              <svg width="16" height="22" viewBox="0 0 16 22" fill="none">
                <path
                  d="M8 0C3.73312 0 0.265625 3.46758 0.265625 7.73438C0.265625 9.17813 0.66532 10.5832 1.42582 11.795L7.4757 21.6956C7.57891 21.8631 7.73359 21.9663 7.91411 21.9921C8.15894 22.0307 8.42977 21.9276 8.57153 21.6827L14.6387 11.6918C15.3605 10.5059 15.7344 9.12661 15.7344 7.73438C15.7344 3.46758 12.2669 0 8 0ZM8 11.6016C5.83446 11.6016 4.13281 9.84844 4.13281 7.73438C4.13281 5.60738 5.873 3.86719 8 3.86719C10.127 3.86719 11.8672 5.60738 11.8672 7.73438C11.8672 9.83555 10.1914 11.6016 8 11.6016Z"
                  fill="#64B5F6"
                />
                <path
                  d="M8 0V3.86719C10.127 3.86719 11.8672 5.60738 11.8672 7.73438C11.8672 9.83555 10.1914 11.6016 8 11.6016V21.9996C8.21996 22.0047 8.44614 21.8993 8.57148 21.6827L14.6387 11.6918C15.3605 10.5059 15.7344 9.12661 15.7344 7.73438C15.7344 3.46758 12.2669 0 8 0Z"
                  fill="#1E88E5"
                />
              </svg>

              <p>AlgoBulls, 99 Wall Street, #2009 New York, NY 10005</p>
            </div>
            <div className="footer-phone" style={{ alignItems: 'flex-start' }}>
              <svg width="16" height="22" viewBox="0 0 16 22" fill="none">
                <path
                  d="M8 0C3.73312 0 0.265625 3.46758 0.265625 7.73438C0.265625 9.17813 0.66532 10.5832 1.42582 11.795L7.4757 21.6956C7.57891 21.8631 7.73359 21.9663 7.91411 21.9921C8.15894 22.0307 8.42977 21.9276 8.57153 21.6827L14.6387 11.6918C15.3605 10.5059 15.7344 9.12661 15.7344 7.73438C15.7344 3.46758 12.2669 0 8 0ZM8 11.6016C5.83446 11.6016 4.13281 9.84844 4.13281 7.73438C4.13281 5.60738 5.873 3.86719 8 3.86719C10.127 3.86719 11.8672 5.60738 11.8672 7.73438C11.8672 9.83555 10.1914 11.6016 8 11.6016Z"
                  fill="#64B5F6"
                />
                <path
                  d="M8 0V3.86719C10.127 3.86719 11.8672 5.60738 11.8672 7.73438C11.8672 9.83555 10.1914 11.6016 8 11.6016V21.9996C8.21996 22.0047 8.44614 21.8993 8.57148 21.6827L14.6387 11.6918C15.3605 10.5059 15.7344 9.12661 15.7344 7.73438C15.7344 3.46758 12.2669 0 8 0Z"
                  fill="#1E88E5"
                />
              </svg>

              <p>
                AlgoBulls Technologies Private Limited, C-212/Mascots, 103/104,
                Orbit Plaza, New Prabhadevi Marg, Mumbai 400025
              </p>
            </div>
          </div>
        </div>

        <div className="footer-disclaimer">
          <p>
            Trading in financial products involves significant risk and may not
            be suitable for all investors. The use of our services, including
            algorithmic trading strategies, Phoenix and Odyssey (Algo
            Marketplace), carries the risk of substantial losses, potentially
            exceeding your deposited funds. It is crucial to fully understand
            these risks before engaging in trading activities.
          </p>
          <p>
            AlgoBulls (AlgoBulls Technologies Private Limited) does not
            guarantee the accuracy or completeness of any information provided
            on our platform, including third-party content. Such information
            should not be relied upon without thorough independent investigation
            by the investor. Investments in securities and equity-related
            instruments are subject to various market risks, which can be
            influenced by specific security factors, broader market conditions,
            and economic, political, and global developments.
          </p>
          <p>
            Past performance of any strategy, model, or advice provided by
            AlgoBulls does not guarantee future results. Actual returns may vary
            significantly due to various factors, including but not limited to,
            impact costs, expenses, entry and exit timings, additional flows or
            redemptions, client-specific mandates, and unique portfolio
            construction characteristics. There is no assurance that the
            objectives of any strategy, model, or advice will be achieved.
          </p>
          <p>
            AlgoBulls, its partners, officers, and employees do not guarantee
            any specific return on investments made based on the strategies or
            advice provided. The value of investments can fluctuate, influenced
            by market forces and conditions. AlgoBulls and its associates are
            not responsible for any losses or shortfalls arising from market
            conditions.
          </p>
          <p>
            Investors are encouraged to thoroughly read and understand the terms
            and conditions outlined in the relevant advisory agreement before
            subscribing to any services. AlgoBulls and its associates/employees
            shall not be held liable for any risks or losses associated with the
            strategies, models, or advice provided. Trading in securities is
            subject to market risks, and AlgoBulls makes no representation or
            guarantee that the objectives of any model, strategy, or advice
            offered will be achieved in the future.
          </p>
          <p>
            <b>Risk Disclosure:</b> Futures and forex trading contains
            substantial risk and is not for every investor. An investor could
            potentially lose all or more than the initial investment. Risk
            capital is money that can be lost without jeopardising ones’
            financial security or lifestyle. Only risk capital should be used
            for trading and only those with sufficient risk capital should
            consider trading. Past performance is not necessarily indicative of
            future results.
          </p>
          <p>
            <b>Hypothetical Performance Disclosure:</b> Hypothetical performance
            results have many inherent limitations, some of which are described
            below. No representation is being made that any account will or is
            likely to achieve profits or losses similar to those shown; in fact,
            there are frequently sharp differences between hypothetical
            performance results and the actual results subsequently achieved by
            any particular trading program. One of the limitations of
            hypothetical performance results is that they are generally prepared
            with the benefit of hindsight. In addition, hypothetical trading
            does not involve financial risk, and no hypothetical trading record
            can completely account for the impact of financial risk of actual
            trading. for example, the ability to withstand losses or to adhere
            to a particular trading program in spite of trading losses are
            material points which can also adversely affect actual trading
            results. There are numerous other factors related to the markets in
            general or to the implementation of any specific trading program
            which cannot be fully accounted for in the preparation of
            hypothetical performance results and all which can adversely affect
            trading results.
          </p>
          <p>
            <b>Testimonial Disclosure:</b> Testimonials appearing on this
            website may not be representative of other clients or customers and
            is not a guarantee of future performance or success.
          </p>
        </div>
      </div>
      <div className="copyright-block">
        <div className="container">
          <div className="privacy-links text-center">
            <Link to="/terms/">Terms of Use</Link>
            <Link to="/privacy-policy/">Privacy Policy</Link>
            <Link to="/disclaimer/">Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  setContactActive: PropTypes.func.isRequired,
};

export default Footer;
